import { HelpCircle } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "Hvilke typer opgaver løser I?",
    a: "Vi udfører konstruktionsarbejde, nedrivning og demontering, renovering og ombygning, opførelse af bygningsdele samt praktiske byggepladsopgaver som materialehåndtering, klargøring og oprydning.",
  },
  {
    q: "Arbejder I kun for virksomheder?",
    a: "Ja. Vi løser opgaver for erhvervskunder som hovedentreprenører, byggevirksomheder, ejendomsselskaber og renoveringsfirmaer – typisk som underentreprenør eller selvstændig leverandør.",
  },
  {
    q: "Hvilke områder dækker I?",
    a: "Vi har base i Randers og løser primært opgaver i Midtjylland. Større projekter i det øvrige Danmark aftales individuelt.",
  },
  {
    q: "Hvordan giver I pris på en opgave?",
    a: "Vi gennemgår opgavens omfang, placering, tidsplan og materialer og sender herefter et konkret tilbud. Alle opgaver aftales individuelt.",
  },
  {
    q: "Kan I rykke ud med kort varsel ved ekstra kapacitetsbehov?",
    a: "Vi tilstræber at være fleksible og finde en løsning, når I mangler kapacitet i en travl periode. Kontakt os, så finder vi ud af, hvad der er muligt.",
  },
  {
    q: "Dokumenterer I det udførte arbejde?",
    a: "Ja. Vi lægger vægt på tydelige aftaler og korrekt dokumentation af det udførte arbejde som en del af leverancen.",
  },
];

export const FAQ = () => (
  <section className="py-20 lg:py-28 bg-gray-50 border-y border-gray-200" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl mb-12">
        <span className="text-[#FF5A00] font-semibold text-sm uppercase tracking-widest">FAQ</span>
        <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 flex items-center gap-3">
          Ofte stillede spørgsmål
        </h2>
      </Reveal>
      <Reveal>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-gray-200" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-lg font-bold text-gray-900 hover:no-underline py-5">
                <span className="flex items-center gap-3">
                  <HelpCircle size={20} className="text-[#FF5A00] shrink-0" />
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-base text-gray-600 leading-relaxed pl-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
